export const colorIndexesPlannedExpenses = {
  green: [12, 7, 13, 16, 19, 14, 17, 15],
  blue: [12, 0, 13, 16, 14, 17, 15, 18],
  red: [12, 0, 13, 16, 14, 34, 15, 18],
  blueGreen: [12, 0, 13, 16, 14, 17, 8, 28],
  blueRed: [12, 18, 13, 16, 14, 17, 15, 33],
  blueYellow: [29, 8, 13, 16, 14, 17, 15, 19],
};

export const colorIndexesVariableExpenses = {
  green: [29, 11, 7, 13, 16, 14, 30, 19, 15, 18, 33],
  blue: [12, 11, 0, 13, 16, 14, 30, 19, 15, 18, 35],
  red: [35, 11, 0, 13, 16, 14, 36, 19, 15, 18, 39],
  blueGreen: [12, 11, 34, 13, 16, 14, 27, 19, 8, 18, 33],
  blueRed: [12, 11, 34, 13, 16, 14, 12, 19, 15, 18, 33],
  blueYellow: [12, 11, 8, 13, 16, 6, 17, 19, 15, 18, 40],
};

export const colorIndexescostPerUnitChart = {
  green: [7, 7, 7],
  blue: [0, 0, 0],
  red: [0, 0, 0],
  blueGreen: [0, 0, 0],
  blueRed: [18, 18, 18],
  blueYellow: [8, 8, 8],
};

export const colorIndexesProjectFinancing = {
  green: [12, 7, 16],
  blue: [5, 0, 15],
  red: [5, 0, 34],
  blueGreen: [5, 0, 6],
  blueRed: [1, 11, 0],
  blueYellow: [29, 9, 0],
};

export const colorIndexesLoanRepaymentSchedule = {
  green: [12, 7],
  blue: [5, 0],
  red: [5, 0],
  blueGreen: [5, 0],
  blueRed: [1, 0],
  blueYellow: [29, 9],
};

export const colorsIndexesRatios = {
  green: [14, 7],
  blue: [17, 0],
  red: [34, 0],
  blueGreen: [6, 5],
  blueRed: [0, 1],
  blueYellow: [0, 29],
};

export const colorsIndexesLineChart = {
  green: [16, 12],
  blue: [26, 5],
  red: [5, 25],
  blueGreen: [19, 5],
  blueRed: [35, 1],
  blueYellow: [5, 29],
};

export const colorsIndexesLiquidity = {
  green: [12, 16],
  blue: [5, 26],
  red: [25, 5],
  blueGreen: [5, 19],
  blueRed: [1, 36],
  blueYellow: [29, 5],
};

export const colorsIndexesEfficiency = {
  green: [12, 15, 16, 14],
  blue: [5, 34, 26, 15],
  red: [5, 25, 13, 34],
  blueGreen: [5, 28, 28, 6],
  blueRed: [1, 36, 0, 23],
  blueYellow: [29, 5, 9, 3],
};

export const colorsIndexesSolvencyRatios = {
  green: [12, 7, 16, 14, 28, 17, 15],
  blue: [5, 0, 34, 15, 18, 6, 14],
  red: [5, 0, 13, 34, 8, 17, 15],
  blueGreen: [0, 5, 6, 28, 24, 17, 15],
  blueRed: [34, 1, 0, 10, 11, 17, 15],
  blueYellow: [9, 29, 0, 34, 13, 17, 15],
};

export const colorIndexesProjectedBalance = {
  green: [7, 12, 14],
  blue: [0, 5, 17],
  red: [0, 5, 34],
  blueGreen: [6, 5, 0],
  blueRed: [0, 1, 31],
  blueYellow: [0, 29, 9],
};

export const colorIndexesCashFlow = {
  green: [7, 12, 14, 16],
  blue: [0, 5, 15, 24],
  red: [0, 5, 13, 34],
  blueGreen: [6, 17, 0, 5],
  blueRed: [0, 12, 8, 1],
  blueYellow: [0, 34, 9, 29],
};

export const colorIndexesFundingDirections = {
  green: [12, 7, 13, 16, 14, 17],
  blue: [5, 0, 13, 16, 14, 17],
  red: [12, 0, 13, 16, 14, 34],
  blueGreen: [5, 10, 0, 13, 6, 33],
  blueRed: [18, 8, 17, 1, 13, 11],
  blueYellow: [29, 21, 8, 13, 16, 32],
};

export const colorIndexesProfitAndLoss = {
  green: [14, 7],
  blue: [17, 0],
  red: [34, 0],
  blueGreen: [6, 5],
  blueRed: [0, 1],
  blueYellow: [0, 29],
};

export const colorIndexesFixedExpenses = {
  green: [20, 11, 12, 21, 7, 13, 24, 16, 25, 28, 19, 15, 26, 18, 22, 23, 14, 27],
  blue: [20, 11, 12, 21, 7, 13, 24, 16, 25, 28, 19, 15, 26, 18, 22, 23, 14, 27],
  red: [20, 11, 12, 21, 7, 13, 24, 16, 25, 28, 19, 15, 26, 18, 22, 23, 14, 27],
  blueGreen: [5, 10, 12, 0, 34, 13, 24, 16, 25, 29, 19, 8, 6, 18, 22, 23, 14, 27],
  blueRed: [20, 11, 12, 21, 34, 13, 24, 16, 25, 28, 19, 15, 26, 18, 22, 23, 14, 27],
  blueYellow: [20, 11, 12, 21, 8, 13, 24, 16, 25, 28, 19, 15, 26, 18, 22, 23, 6, 27],
};

export const colorIndexesGeneralExpenses = {
  green: [20, 11, 12, 21, 7, 13, 24, 16, 28, 19, 15, 26, 18, 22, 14],
  blue: [20, 12, 21, 7, 13, 24, 16, 25, 19, 15, 26, 18, 22, 23, 27],
  red: [20, 11, 12, 21, 7, 13, 24, 16, 28, 19, 15, 26, 22, 23, 27],
  blueGreen: [5, 4, 12, 0, 34, 13, 24, 29, 28, 19, 8, 18, 22, 23, 14],
  blueRed: [20, 11, 12, 21, 34, 16, 17, 28, 19, 15, 26, 18, 22, 23, 14],
  blueYellow: [20, 11, 12, 21, 7, 13, 28, 19, 15, 26, 18, 22, 23, 14, 27],
};

export const colorIndexesMarketingExpenses = {
  green: [20, 11, 21, 7, 13, 24, 16, 28, 15, 26, 18, 23, 27],
  blue: [20, 12, 21, 0, 24, 16, 25, 19, 26, 18, 22, 23, 27],
  red: [20, 12, 21, 0, 13, 24, 16, 28, 15, 18, 22, 23, 27],
  blueGreen: [5, 10, 12, 0, 34, 13, 24, 28, 19, 18, 22, 23, 14],
  blueRed: [20, 11, 12, 21, 34, 16, 17, 28, 19, 18, 22, 23, 14],
  blueYellow: [20, 11, 12, 21, 8, 13, 28, 19, 15, 26, 18, 23, 27],
};

export const colorIndexesRAndD = {
  green: [12, 11, 7, 24, 16, 18, 14],
  blue: [20, 12, 0, 13, 25, 22, 27],
  red: [20, 12, 0, 13, 16, 22, 27],
  blueGreen: [5, 10, 0, 13, 24, 19, 14],
  blueRed: [20, 12, 21, 16, 17, 15, 14],
  blueYellow: [20, 12, 21, 13, 28, 15, 27],
};
